import {
  DataTableAssign,
  DataTableAssignProps,
} from "@/components/custom/data-table/data-table-assign";
import { ClustersTableContext } from "./-clusters-table-context.tsx";

export function ClustersTable(props: Omit<DataTableAssignProps, "context">) {
  return (
    <DataTableAssign
      context={ClustersTableContext}
      pageOptions={[50, 100, 200]}
      {...props}
      stickyHeader={true}
    />
  );
}
